import _ from "lodash"

// A rate category name lives twice in a ratesheet: as a key of each rates
// hash (rewritten by deepCamelizeKeys/deepSnakeizeKeys on load/save) and as
// a plain value in category_order/categories (never rewritten). Only a name
// that both transforms leave alone is safe — practically, a lowercase
// snake_case word. Normalize on entry so a typed "Student" cannot diverge
// into rates["student"] vs category_order ["Student"], which the backend
// rejects ("category_order is missing categories: student").
export const normalizeCategoryName = (category: string): string =>
  _.snakeCase(_.trim(category || ""))
